import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { POSITIONS } from '../../config/positions';
import { playerComparisonFiltersSelector } from 'store/modules/statspro/player-comparison/selectors/filters-selector';
import { getTranslation } from 'common/react/utils/translations';
import { SelectMultiple } from 'common/react/components/select-multiple';
import { playerComparisonActions } from 'common/store/modules/statspro/player-comparison';

export const PlayerSelectionPositionsFilters = ({ addOnResetCallback }) => {
    const dispatch = useDispatch();

    const filters = useSelector(playerComparisonFiltersSelector);
    const updateFilterItem = (filterItem, value) => {
        dispatch(
            playerComparisonActions.setFilterItem({
                filterItem,
                value
            })
        );
    };

    return (
        <SelectMultiple
            // @ts-ignore
            items={POSITIONS}
            getInitialSelectedItems={() => {
                return POSITIONS.filter((p) =>
                    filters.positions.includes(p.keys)
                );
            }}
            label={getTranslation('label.statsLeaders.filters.position')}
            icon="player-position"
            itemToString={(pos) => pos.name}
            onSelectedItemsChange={(pos) => {
                updateFilterItem(
                    'positions',
                    pos.map((p) => p.keys)
                );
            }}
            addOnResetCallback={addOnResetCallback}
            getItemText={(item) => item.name}
            getItemLabel={(item) => item.name}
        />
    );
};

PlayerSelectionPositionsFilters.propTypes = {
    addOnResetCallback: PropTypes.func
};
